<template>
  <div id="app">
    <app-header-home v-if="$route.name === 'home'"></app-header-home>
    <app-header v-else></app-header>
    <app-breadcrumbs v-if="$route.name !== 'home'"></app-breadcrumbs>
    <router-view class="main-content"/>
    <app-partners></app-partners>
    <app-footer></app-footer>
    <vue-alert></vue-alert>
  </div>
</template>

<script>
import { errorInterceptor } from "@/utils/helpers";

import {
  AppHeader,
  AppHeaderHome,
  AppFooter,
  AppFeedback,
  AppPartners,
  AppBreadcrumbs,
  AppFeedbackModal
} from "@/components";

export default {
  name: "App",
  components: {
    AppHeader,
    AppHeaderHome,
    AppPartners,
    AppFeedback,
    AppFooter,
    AppBreadcrumbs,
    AppFeedbackModal
  },
  created() {
    errorInterceptor.apply(this);
  }
};
</script>
<style lang="scss">
@import "../node_modules/bootstrap/scss/bootstrap-grid";
@import "../node_modules/bootstrap/scss/bootstrap-reboot";
@import "../node_modules/bootstrap/scss/nav";
@import "../node_modules/bootstrap/scss/buttons";
@import "../node_modules/bootstrap/scss/forms";
@import "../node_modules/bootstrap/scss/utilities/text";

.main-content {
  padding-bottom: 50px;
}
</style>
